<template>
	<p class="is-size-4 mb-4"><span class="bold-text">Selected Plan:</span> {{ selectedPlan.title }} </p>
	<button class="button is-primary mb-3 bold-text" @click="backBtnClick">Change Selection</button>
	<div :style="{height: '90vh'}">
		<iframe allow="payment" :src="iframeSrc" :style="{width: '100%', height: '100%'}" />
	</div>
</template>
<script lang="ts">
import config from "@/config";
import { Steps } from "@/models/LeadsState";
import { LeadsActions } from "@/store/modules/leads/actions";
import { LeadsGetters } from "@/store/modules/leads/getters";
import { LeadsMutations } from "@/store/modules/leads/mutations";
import { STATE_MODULES } from "@/store/state-modules";
import { paymentUtils } from "@puls/puls-general-utils";
import { defineComponent } from "vue";
import { mapGetters, mapState } from "vuex";

export default defineComponent({
	mounted () {
		window.addEventListener('message', this.listenToPaymentEvent.bind(this));
		this.$store.dispatch(`${STATE_MODULES.LEADS}/${LeadsActions.SET_PAYMENT_DATA}`)
	},
	unmounted () {
		window.removeEventListener('message', this.listenToPaymentEvent.bind(this));	
	},
	computed: {
		...mapState(STATE_MODULES.LEADS, ['uuid']),
		...mapGetters(STATE_MODULES.LEADS, { 
			selectedPlan: LeadsGetters.SELECTED_PLAN
		}),
		iframeSrc (): string {
			return `${config.domain}/payments?guid=${this.uuid}&type=recruitment&email=context_object&is_app_mode=1`
		}
	},
	methods: {
		listenToPaymentEvent (messageEvent: any) {
			paymentUtils.listenToRecruitmentPaymentNonceEvent(messageEvent, () => {
				this.$store.commit(`${STATE_MODULES.LEADS}/${LeadsMutations.SET_STEP}`, Steps.THANK_YOU)
			});
		},
		backBtnClick () {  
			this.$store.commit(`${STATE_MODULES.LEADS}/${LeadsMutations.TOGGLE_SELECTED_PLAN}`, this.selectedPlan.id)		
			this.$store.commit(`${STATE_MODULES.LEADS}/${LeadsMutations.SET_STEP}`, Steps.SELECT_PLAN);
		}
	}
})
</script>

<style scoped>

</style>
